import NativeRNExitApp from "./NativeRNExitApp";

var RNExitApp = {
  exitApp: function() {
    NativeRNExitApp.exitApp();
  }
};

export default RNExitApp;
